(function overrideConsoleError() {
    const originalConsoleError = console.error;

    const cleanString = (input: string): string =>
        input.replace(/[\r\n]+/g, " ").replace(/\s+/g, " ");

    const customStringify = (obj: unknown): string => {
        return JSON.stringify(
            obj,
            (key, value) => {
                if (value instanceof Error) {
                    const errorObj: Record<string, unknown> = {
                        name: value.name,
                        message: value.message,
                        stack: value.stack,
                    };
                    Object.getOwnPropertyNames(value).forEach((prop) => {
                        // @ts-expect-error type 'string' can't be used to index type 'Error'
                        errorObj[prop] = value[prop];
                    });
                    return errorObj;
                }
                return value;
            },
            2
        );
    };

    console.error = (...args: unknown[]): void => {
        const formattedArgs = args.map((arg) => {
            if (typeof arg === "string") {
                return cleanString(arg);
            }

            try {
                return cleanString(customStringify(arg));
            } catch {
                // If JSON.stringify fails, return the original argument
                return arg;
            }
        });

        originalConsoleError(...formattedArgs);
    };
})();
export {};
